import { RouteComponentProps } from 'react-router-dom';
import { InverseDropdown } from './styles'
import { NavItem } from 'react-bootstrap';
import { IGroup } from '@nkr/models/group';
import { IRole } from '@nkr/models/index';
import { AuthRole } from '@nkr/enums/auth-role';
import IldaMenus from './ilda-menus';

interface IProps extends RouteComponentProps<{}> {
    firstName: string,
    lastName: string,
    username: string,
    currentUrl: string,
    group: IGroup
    roles: IRole[]
}

const NkdoMenus = (props: IProps) => {
    const isDonorConnect = props.location.pathname.includes('/donor-connect');
    const isDefault = !props.location.pathname.includes('/ilda') && !props.location.pathname.includes('/donor-connect')
    const isDonorConnectAccessAll = props.roles.filter(x => x.id == AuthRole.DonorConnectAccessAll).length > 0;
    const isDonorConnectAccessAssigned = props.roles.filter(x => x.id == AuthRole.DonorConnectAccessAssigned).length > 0;
    const canAccessIlda = props.roles.filter(x => x.id == AuthRole.IldaAccessAll).length > 0;

    if (isDonorConnect || isDefault) {
        return (
            <div className='nkr-menu'>
                <div className='navbar navbar-inverse' style={{ borderRadius: 0, marginBottom: 10 }}>
                    <div className='navbar-header'>
                        <button type='button' className='navbar-toggle' data-toggle='collapse' data-target='.navbar-collapse' style={{ marginTop: 1, height: 18, padding: '5px 18px' }}>
                            <span className='sr-only'>Toggle navigation</span>
                            <span className='icon-bar'></span>
                            <span className='icon-bar'></span>
                            <span className='icon-bar'></span>
                        </button>
                    </div>
                    <div className='navbar-collapse collapse'>
                        <ul className='nav navbar-nav'>
                            <li className={isDonorConnect ? 'dropdown active' : 'dropdown'}>
                                <a href='#' className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Donor Mentor <span className='caret'></span></a>
                                <InverseDropdown className='dropdown-menu'>
                                    <li>
                                        <a href={isDonorConnectAccessAll ? '/donor-connect/unassigned' : '/donor-connect/to-do'}>DASH Registrations</a>                                        

                                        {(isDonorConnectAccessAll || isDonorConnectAccessAssigned) && (
                                            <a href={'/admin/donor-connect/canned-responses'}>Donor Mentor Canned Responses</a>
                                        )}

                                        <a href={`/donor-connect/incident-report`}>Donor Mentor Incident Report List</a>

                                        {(isDonorConnectAccessAll || isDonorConnectAccessAssigned) && (
                                            <>
                                                <a href={`/donor-connect/report/completions`}>Mentor Completions</a>
                                                <a href={`/donor-connect/report/donor-connect-mentor-performance`}>Mentor Performance Report</a>
                                            </>
                                        )}

                                        {(isDonorConnectAccessAll) && (
                                            <a href={`/donor-connect/user-case-load-limits`}>User Case Load Limits</a>
                                        )}
                                    </li>
                                </InverseDropdown>
                            </li>

                            {canAccessIlda && (
                                <NavItem active={props.location.pathname == '/ilda/to-do'} href={'/ilda/to-do'}>ILDA</NavItem>
                            )}

                            {props.group.accessTicketing && isDonorConnectAccessAll && (
                                <NavItem active={props.location.pathname == '/ticketing/tickets'} href={'/ticketing/tickets'}>Ticketing</NavItem>
                            )}

                            <li className='dropdown'>
                                <a href='#' className='dropdown-toggle' data-toggle='dropdown' role='button' aria-haspopup='true' aria-expanded='false'>Welcome, {props.firstName} {props.lastName} <span className='caret'></span></a>
                                <InverseDropdown className='dropdown-menu'>
                                    <li>
                                        <a href={'/manage-account'}>Manage Account</a>
                                        <a href={'/logout?next=' + props.currentUrl}>Logout</a>
                                    </li>
                                </InverseDropdown>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <IldaMenus
                firstName={props.firstName}
                lastName={props.lastName}
                username={props.username}
                currentUrl={props.currentUrl}
                group={props.group}
                history={props.history}
                location={props.location}
                match={props.match}
                roles={props.roles}
            />
        );
    }
}

export default NkdoMenus;
